import IconButton from '@mui/material/IconButton';
import styled from 'styled-components';

import colors from 'app/styles/theme/colors';
import { StyledDialog as BaseStyledDialog } from 'app/components/StyledDialog/styles';
import { dialogPaper } from 'app/components/DialogFrame/styles';

export {
  Head,
  Title,
  Description,
  Body,
  Foot,
  ResultState,
  ResultIcon,
  ResultTitle,
  ResultMessage,
} from 'app/components/DialogFrame/styles';
export { SecondaryButton, PrimaryButton } from 'app/components/DialogFooterButtons/styles';

const { gray } = colors.designSystem;

export const StyledDialog = styled(BaseStyledDialog)`
  .MuiDialog-paper {
    width: 640px;
    ${dialogPaper}
  }
`;

export const CloseButton = styled(IconButton)`
  color: ${gray[700]} !important;
  padding: 4px !important;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const WarningBanner = styled.div`
  display: flex;
  margin-top: 16px;
  padding: 16px 24px;
  align-items: center;
  gap: 16px;
  align-self: stretch;

  border-radius: 8px;
  border: 1px solid #ffeeb3;
  background: #fff9e6;

  svg {
    font-size: 32px;
    color: #ffb822;
    flex-shrink: 0;
  }

  span {
    color: ${gray[800]};
    font-size: 14px;
    line-height: 1.25rem;
  }

  strong {
    font-weight: 600;
  }
`;

export const SummaryList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
`;

export const SummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  span {
    color: ${gray[800]};
    font-size: 14px;
    font-weight: 400;
  }
`;

